<script>
export default {
  components: {},
  data() {
    return {
      date: new Date(),
    }
  },
  computed: {
    year: function () {
      return this.date.getFullYear()
    },
  },
  created: () => {
    document.body.classList.add('authentication-bg')
    document.body.classList.add('authentication-bg-pattern')
  },
}
</script>

<template>
  <div>
    <div class="account-pages mt-5 mb-5">
      <div class="container">
        <slot />
      </div>
    </div>
    <footer class="footer footer-alt">
      WellKey - PT. RIGSIS Energi Indonesia © {{ year }}
    </footer>
  </div>
</template>
